import {
  MODEL_WISE_COMPOSITION,
  MODEL_WISE_DATA,
  MODEL_WISE_GET_MODELS,
  MODEL_WISE_REPORT,
  MODEL_WISE_TABLE_DATA,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getCarModels = (search) => {
  const requestURL = MODEL_WISE_GET_MODELS;
  let obj = {};

  if (search) {
    obj["search_string"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getModelWiseData = (value, location, model, page, limit, sort) => {
  const requestURL = MODEL_WISE_DATA;
  let obj = { value_by: value };

  if (location && location.length) {
    obj["location"] = location.join(",");
  }

  if (model && model.length) {
    obj["models"] = model.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, sort: sort },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getModelWiseComposiion = (
  value,
  location,
  model,
  page,
  limit,
  sort
) => {
  const requestURL = MODEL_WISE_COMPOSITION;
  let obj = { value_by: value };

  if (location && location.length) {
    obj["location"] = location.join(",");
  }

  if (model && model.length) {
    obj["models"] = model.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, sort: sort },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getModelWiseReport = (location) => {
  const requestURL = MODEL_WISE_REPORT;
  let obj = {};

  if (location && location.length) {
    obj["location"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getModelWiseTableData = (location, model, page, limit) => {
  const requestURL = MODEL_WISE_TABLE_DATA;
  let obj = {};

  if (location && location.length) {
    obj["location"] = location.join(",");
  }

  if (model && model.length) {
    obj["models"] = model.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
